import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '@teorema/patron';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { utils } from 'src/app/shared';
import { AuthService } from '../auth.service';

@Component({
  templateUrl: './confirm-email.component.html',
  standalone: false,
})
export class ConfirmEmailComponent implements OnInit, OnDestroy {
  user: User = utils.getUser();
  tabTitle: string = `Olá ${this.user.name}!`;
  sub?: Subscription;
  loadingConfirm: boolean = false;
  loadingSendEmail: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.loadingConfirm = true;
    this.authService
      .me()
      .then(user => {
        if (user) {
          this.user = user;
          utils.setUser(this.user);
        }
      })
      .finally(() => {
        this.loadingConfirm = false;
      });

    this.sub = this.activatedRoute.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        utils.setToken(token);
        if (!this.user.email_verified_at) {
          this.confirmEmail();
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  async confirmEmail() {
    this.loadingConfirm = true;
    const response: any = await this.authService
      .confirmEmail()
      .catch(err => {
        if (!err?.messageShown)
          this.toastService.show({ color: 'error', message: 'Houve um erro ao confirmar o email' });
      })
      .finally(() => {
        this.loadingConfirm = false;
      });

    const { email_verified_at } = response;
    if (email_verified_at) {
      this.user.email_verified_at = email_verified_at;
      utils.setUser(this.user);
    }
  }

  sendConfirmationEmail() {
    this.loadingSendEmail = true;
    this.authService
      .sendConfirmationEmail()
      .then((response: any) => {
        if (response.message == 'ok')
          this.toastService.show({
            color: 'success',
            message: `Um novo e-mail de confirmação foi enviado para ${this.user.email}`,
          });
      })
      .catch(err => {
        if (!err?.messageShown)
          this.toastService.show({ color: 'error', message: 'Houve um erro ao enviar o email' });
      })
      .finally(() => {
        this.loadingSendEmail = false;
      });
  }
}
